import styles from "./shop.module.css";
import ax1 from "assets/images/img525.jpg";
import ax3 from "assets/images/img525.svg";
const ShopItem = ({ item, onClick, selectedId }) => {
  return (
    <div
      className={`d-flex flex-columnjustify-content-evenly align-items-center text-light ${styles.cryptCard2} `}
    >
      {item.coverImg ? (
        <img src={item.coverImg} className={styles.ax1} />
      ) : (
        <img src={ax1} className={styles.ax1} />
      )}
      <div className={styles.up}>
        <div className="w-100 pt-2 px-3"></div>

        <div className="d-flex flex-column justity-content-center align-items-center">
          {item.logoImg ? (
            <img src={item.logoImg} className={styles.ax5} />
          ) : (
            <img src={ax3} className={styles.ax5} />
          )}
          <p style={{ fontSize: "15px", marginTop: "5px" }}>{item.title}</p>
        </div>
      </div>
    </div>
  );
};

export default ShopItem;
